const EVAL = (that, f, ...args) => (typeof f === 'function' ? f.apply(that, args) : f)
const EMPTY_FUNC = (i => i)

export default {
  props: {
    defines: Object,
  },
  methods: {
    prop(key) {
      let prop = {}
      if (this.defines && this.defines.props) {
        prop = this.defines.props[key] || {}

        // Update type default
        if (prop.type === 'state') {
          if (!prop.formatter)
            prop.formatter = function (value) { return this.$formatters.state_label(value) }
          if (!prop.innerClasses)
            prop.innerClasses = function (value) { return `ui label ${this.$formatters.state_class(value)}` }
        } else if (prop.type === 'date') {
          if (!prop.formatter)
            prop.formatter = function (value) { return this.$formatters.date.to_date(value) }
        } else if (prop.type === 'time') {
          if (!prop.formatter)
            prop.formatter = function (value) { return this.$formatters.date.to_datetime(value) }
        } else if (prop.type === 'money') {
          if (!prop.formatter)
            prop.formatter = function (value) { return this.$formatters.money(value) }
        }

        // Prototypes
        if (!prop.$value) {
          const formatter = prop.formatter || EMPTY_FUNC
          prop.$value = (record = {}) => formatter.call(this, record[key], record)
        }

        if (!prop.$select)
          prop.$select = (record = {}) => EVAL(this, prop.select, record[key], record)

        if (!prop.$readonly)
          prop.$readonly = (record = {}) => EVAL(this, prop.readonly, record[key], record)

        if (!prop.$type)
          prop.$type = (record = {}) => EVAL(this, prop.type, record[key], record)

        if (!prop.$innerClasses)
          prop.$innerClasses = (record = {}) => EVAL(this, prop.innerClasses, record[key], record)

        if (!prop.$classes)
          prop.$classes = (record = {}) => EVAL(this, prop.classes, record[key], record)
      }
      return prop
    },
    getLayout(layout = 'default') {
      return this.defines.layouts[layout]
    },
    action(key) {
      if (key === Object(key))
        return key
      if (this.defines && this.defines.actions)
        return this.defines.actions[key] || {}
      return {}
    },
    propFormatter(record, key) {
      const formatter = this.prop(key).formatter || EMPTY_FUNC
      return formatter.call(this, record[key], record)
    },
    actionHandler(record, key, type = 'left') {
      let action_name
      if (type === 'left')
        action_name = `action:${key}`
      else
        action_name = `action:${type}:${key}`
      const handler = this.action(key).handler || (() => { this.$emit(action_name, record) })
      handler.call(this, record)
    },
    getFilter(filter_name) {
      return (this.defines.filters || {})[filter_name] || (() => true)
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/components/auto/mixin.js